// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-image-viewer',
    // #endregion
    // #region Properties
    data: () => ({
        currentImage: {},
    }),
    props: {
        title: {
            type: String,
            required: false,
            default: 'Bilder',
        },
        showThumbnails: {
            type: Boolean,
            required: false,
            default: true,
        },
        flags: {
            type: Array,
            required: false,
            default: [],
        },
        images: {
            type: Array,
            required: false,
            default: [],
        },
        imageSpacing: {
            type: String,
            required: false,
            default: '10px',
        },
    },
    // #endregion
    // #region Core
    computed: {
        showPreviousButton() {
            if (!this.currentImage) {
                return false;
            }
            return this.images.indexOf(this.currentImage) > 0;
        },
        showNextButton() {
            if (!this.currentImage) {
                return false;
            }
            return this.images.indexOf(this.currentImage) < this.images.length - 1;
        },
    },
    // #endregion
    // #region Watch
    watch: {
        'images': function (value) {
            //Reload
            this.$refs.slider?.reload();
            //Set
            if (value && value.length > 0) {
                this.OnSelect(value[0]);
            }
            else {
                this.currentImage = undefined;
            }
        },
    },
    // #endregion
    // #region Methods
    methods: {
        // #region Events
        OnSelect(image) {
            //Current
            this.currentImage = image;
            //Scroll
            this.$refs.slider?.scrollToIndex(this.images.indexOf(image), 'auto');
        },
        OnScroll(event) {
            var element = event.target;
            if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                //host.notification.showToast("End");
            }
            else if (element.scrollTop == 0) {
                //host.notification.showToast("top", "info");
            }
        },
        OnMoveNext() {
            if (!this.showNextButton) {
                return;
            }
            this.OnSelect(this.images[this.images.indexOf(this.currentImage) + 1]);
        },
        OnMovePrevious() {
            if (!this.showPreviousButton) {
                return;
            }
            this.OnSelect(this.images[this.images.indexOf(this.currentImage) - 1]);
        },
        OnImagelick() {
            host.notification.showModal(this.$host.components.getComponent("g-gallery-modal"), {
                title: this.title,
                images: this.images,
                selectedImage: this.currentImage
            }, {
                size: 'full'
            });
        },
        onScrollDebounce({ scrollWidth, width, left }) {
            this.currentImage = this.images[Math.round(left / width)];
        },
        // #endregion
        // #region Move
        imgMouseEntry(event) {
            //Element
            let tElement = event.target;
            //Zoom
            tElement.classList.remove("normal-zoom");
            tElement.classList.add("zoom-in");
        },
        //https://stackoverflow.com/questions/51256570/move-img-with-mousemove/51256755
        imgMouseMove(event) {
            //Element
            var tTarget = event.target;
            // This gives you the position of the image on the page
            var bbox = tTarget.getBoundingClientRect();
            // Then we measure how far into the image the mouse is in both x and y directions
            var mouseX = event.clientX - bbox.left;
            var mouseY = event.clientY - bbox.top;
            // Then work out how far through the image as a percentage the mouse is
            var xPercent = (mouseX / bbox.width) * 100;
            var yPercent = (mouseY / bbox.height) * 100;
            tTarget.style.setProperty("transform-origin", (xPercent + '% ' + yPercent + '%'));
        },
        imgMouseLeave(event) {
            //Element
            let tElement = event.target;
            //Zoom
            tElement.classList.remove("zoom-in");
            tElement.classList.add("zoom-normal");
        },
        // #endregion
        // #region Helper
        isActiveImage(image) {
            return image === this.currentImage;
        },
        isVideo(address) {
            return !utils.isNullOrEmpty(address) && address.startsWith('video://');
        },
        // #endregion
    }
    // #endregion
});
// #endregion
